export default "__VITE_ASSET__9b5884fe__"